// extracted by mini-css-extract-plugin
module.exports = {"container":"PrintFooter_container__1Ya7w","signature":"PrintFooter_signature__1PsBG","date":"PrintFooter_date__2szbD"};